import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { StyledNavWrapper, StyledNav, StyledNavLink } from './styled-nav-elements';
import { breakpoints } from '../helpers/breakpoints';

import festivalHomesIcon from '../../static/festival-homes-icon.svg';
import facebookLogo from '../../static/facebook-logo.svg';
import instagramLogo from '../../static/instagram-logo.svg';

const footerLinks = [
  // {
  //   name: 'About',
  //   link: '/',
  // },
  // {
  //   name: 'News',
  //   link: '/',
  // },
  // {
  //   name: 'FAQS',
  //   link: '/',
  // },
];

const footerSocialLinks = [
  {
    name: 'Instagram',
    link: 'https://www.instagram.com',
    icon: facebookLogo,
  },
  {
    name: 'Facebook',
    link: 'https://www.facebook.com',
    icon: instagramLogo,
  },
];

const FooterNavWrapper = styled(StyledNavWrapper)`
  display: flex;
  flex-direction: column;
  .footer__logo {
    margin-bottom: var(--v-spacing);
    @media screen and (min-width: ${breakpoints.md}) {
      margin-bottom: 0;
    }
  }
  @media screen and (min-width: ${breakpoints.md}) {
    flex-direction: row;
  }
`;

const StyledFooterSocialLinksWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: var(--v-spacing);
  @media screen and (min-width: ${breakpoints.md}) {
    margin-top: 0;
    margin-left: auto;
  }
`;

const StyledSocialLabel = styled.span`
  margin-right: 1.5rem;
  font-size: 1.4rem;
`;

const StyledSocialLink = styled.a`
  &:not(:last-of-type) {
    margin-right: 1.5rem;
  }
`;

const Footer = () => {
  return (
    <FooterNavWrapper as={'footer'}>
      <Link to={'/'}>
        <img src={festivalHomesIcon} alt={'Festival Homes Icon'} className="footer__logo" />
      </Link>
      <StyledNav>
        {footerLinks.map(link => {
          return (
            <StyledNavLink to={link.link} activeStyle={{ color: 'var(--c-red)' }} key={link.name}>
              {link.name}
            </StyledNavLink>
          );
        })}
      </StyledNav>
      <StyledFooterSocialLinksWrapper>
        {/* <StyledSocialLabel>Follow</StyledSocialLabel> */}
        {footerSocialLinks.map(link => {
          return (
            <StyledSocialLink
              href={link.link}
              target={'_blank'}
              rel={'noopener'}
              activeStyle={{ color: 'var(--c-red)' }}
              key={link.name}
              aria-label={`Visit Festival Homes ${link.name} page`}
            >
              <img width={36} src={link.icon} alt={`${link.name} logo`} />
            </StyledSocialLink>
          );
        })}
      </StyledFooterSocialLinksWrapper>
    </FooterNavWrapper>
  );
};

export default Footer;
